import React from 'react';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';

import { CommonTable } from '../../common-components/CommonTable';
import { useKnowledgeBaseList } from './hooks/useKnowledgeBaseList';
import { useKnowledgeBaseTableHeader } from './hooks/useKnowledgeBaseTableHeader';
import type { IKnowledgeBaseItem } from './slice/types';

export default function KnowledgeBase() {
  const columns = useKnowledgeBaseTableHeader();
  const {
    items,
    total,
    isLoading,
    error,
    pageIndex,
    setPageIndex,
    rowsPerPage,
    setRowsPerPage,
    currentProduct,
    syncBlogs,
    // customSync,
    isSyncingBlogs,
    isCustomSyncing,
  } = useKnowledgeBaseList();

  return (
    <Box sx={{ width: '100%', overflowY: 'auto', height: '100dvh ', px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 } }}>
      <Box sx={{ maxWidth: 1280, mx: 'auto', width: '100%' }}>
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ height: '100px' }} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent="space-between" spacing={2}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AutoStoriesRoundedIcon color="primary" />
              Knowledge Base
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
              <Chip size="small" label={currentProduct ?? '—'} />
              <Chip size="small" variant="outlined" label={`${total || items.length} total`} />
            </Stack>
          </Box>

          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ width: { xs: '100%', md: 'auto' } }}>
            <Button variant="contained" onClick={syncBlogs} disabled={isSyncingBlogs || isCustomSyncing}>
              {isSyncingBlogs ? 'Syncing Blogs...' : 'Sync Blogs'}
            </Button>
            {/* <Button variant="outlined" onClick={customSync} disabled={isSyncingBlogs || isCustomSyncing}>
              {isCustomSyncing ? 'Syncing...' : 'Custom Sync'}
            </Button> */}
          </Stack>
        </Stack>

        <Box sx={{ height: 'calc(100dvh - 200px)', backgroundColor: 'transparent!important' }}>
          <CommonTable<IKnowledgeBaseItem>
            columns={columns}
            rows={items}
            getRowId={(item) => item._id}
            isLoading={isLoading}
            error={error}
            emptyLabel="No knowledge base items found for this product."
            pagination={{
              page: pageIndex,
              rowsPerPage,
              total: total || items.length,
              onPageChange: (next) => setPageIndex(next),
              onRowsPerPageChange: (next) => {
                setRowsPerPage(next);
                setPageIndex(0);
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}